import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

type PageProps = {
    title?: string,
    render: React.ReactNode;
}

export const Page = ({ title = "", render }: PageProps) => {
    const { pathname } = useLocation();

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 1000);
    }, [pathname]);

    useEffect(() => {
        document.title = title + "Teenfure Job Portal";
    }, [title])

    return <>{render}</>;
};

export default Page;